<template>
    <!-- 商品购买赠送管理－售卖明细 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'giveActiveSellDetail')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="支付时间">
                        <a-range-picker
                            style="width:282px"
                            showTime
                            format="YYYY/MM/DD HH:mm"
                            v-decorator="['payTime']"
                        />
                    </a-form-item>
                    <a-form-item label="订单状态">
                        <a-select allowClear :options="$utils.EsTradeStateOptions" placeholder="请选择" v-decorator="['tradeState']"></a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset" class="mr8">重置</a-button>
<!--                        <a-button @click="exportExcel" :loading="loading" type="primary">导出</a-button>-->
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <a-card>
                    <template slot="extra">
                        <template>
                            <a-button type="primary" @click="exportExcel" :loading="loading">导出excel</a-button>
                            <a-button @click="openExportModal">导出记录</a-button>
                        </template>
                        <a-button @click="$router.back()">返回</a-button>
                    </template>
                    <template slot="title">
                        <div class="font-normal" style="font-weight: 400;">
                            <span class="mr16">活动名称：<span class="text-primary">{{orderData.ticketName}}</span></span>
                            <span class="mr16">活动期间：<span class="text-primary">{{orderData.startTime}} 至 {{orderData.endTime}}</span></span>
                            <span>售卖份数：<span class="text-primary">{{orderData.sellNum}}</span></span>
                        </div>
                    </template>
                    <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="changePage"
                    :rowKey="record => record.tradeNo"
                    >
                        <template slot="myToFixed2" slot-scope="key ,row">
                            {{key | myToFixed2}}
                        </template>
                        <template slot="isEmpty" slot-scope="key ,row">
                            {{key | isEmpty}}
                        </template>
                        <span slot="action" slot-scope="a,row">
                            <a class="text-primary" @click="goToOrderDetail(row.tradeNo)">订单详情</a>
                        </span>
                    </a-table>
                </a-card>
            </div>
        </content-view>
        <report-export-modal ref="reportExportModal" :exportType="21"></report-export-modal>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
const columns = [
    {
        title: "交易订单号",
        dataIndex: "tradeNo"
    },
    {
        title: "用户手机号",
        dataIndex: "phone"
    },
    {
        title: "购买张数",
        dataIndex: "activityTicketNum",
        scopedSlots: { customRender: "isEmpty" }
    },
    {
        title: "支付金额",
        dataIndex: "payAmount",
        scopedSlots: { customRender: "myToFixed2" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "isEmpty" }
    },
    {
        title: "订单状态",
        dataIndex: "tradeState"
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }
];
export default {
    name: "giveActiveSellDetail",
    components: {},
    props: {},
    data() {
        return {
            columns,
            orderData: {
                basePage: {
                    data: []
                }
            },
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            detailData: {},
            visible: false,
            redemptionAddr: '',
            loading: false
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    methods: {
        handleReset() {
            this.form.resetFields();
            this.pagination.pageSize = 20;
            this.pagination.current = 1;
            this.getList();
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize;
            this.pagination.current = page.current;
            this.getList();
        },
        getInfo() {
            if(!this.shopId) return
            this.form.validateFields((err, values) => {
                if (err) return;
                values.ticketGiveId = this.$route.params.id;
                const payTime = values['payTime'] ? values['payTime'] : [];
                values.startTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined;
                values.endTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined;
                delete values.payTime;
                this.loading = true
                this.$api.changeCode.ticketGiveOrder({
                    body: values
                }).then(res => {
                    this.loading = false;
                    if (!res) return;
                    this.orderData = res;
                }).catch(err => {
                    this.loading = false;
                })
            });
        },
        getList() {
            if(!this.shopId) return
            this.form.validateFields((err, values) => {
                if (err) return;
                values.activityId = this.$route.params.id;
                const payTime = values['payTime'] ? values['payTime'] : [];
                values.minPayTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined;
                values.maxPayTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined;

                delete values.payTime;
                this.loading = true
                this.$api.order.orderSearch({
                    query: {
                        ...values,
                        goodsType: "TICKET",
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        category: 'Buy,GoodsGrant'
                    }
                })
                .then(res => {
                    this.loading = false;
                    if (!res) return;
                    this.dataSource = res.list;
                    this.pagination.total = res.total;
                }).catch(err => {
                    this.loading = false;
                })
            });
        },
        /**
         * @goToOrderDetail 查看订单详情
         */
        goToOrderDetail(orderId) {
            this.$router.push({name: 'buyOrder', params: {orderId}});
        },
        // 导出excel
        exportExcel() {
            this.form.validateFields((err, values) => {
                if (err) return;
                values.activityId = this.$route.params.id;
                const payTime = values['payTime'] ? values['payTime'] : [];
                values.minPayTime = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD') : undefined;
                values.maxPayTime = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD') : undefined;
                delete values.payTime;
                this.loading = true
                this.$api.order.orderExport({
                    query: {
                        ...values,
                        pageNum: 1,
                        pageSize: this.pagination.total,
                        category: 'Buy,GoodsGrant'
                    }
                }).then(res => {
                    this.$refs.reportExportModal.open();
                    this.loading = false
                }).catch( err => {
                    this.loading = false
                })
            });
        },
        /**
         * @func openExportModal 打开导出记录弹窗
         */
        openExportModal() {
            this.$refs.reportExportModal.open();
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getInfo();
        this.getList();
    },
    watch: {
        'shopId'() {
            this.$router.back();
        }
    }
};
</script>
<style lang="scss">
</style>
